import AdminProductStockControl from './AdminProductStockControl';

export default AdminProductStockControl;
